<div class="footer cipo-bg--primary-50">
    ©
    <span>{{ year }}</span>
    &nbsp;
    <a href="https://cipocloud.com" target="_blank">CIPO Cloud Software</a>
    <br />
    All rights reserved.
    <br />
    v{{ version }}
</div>
